import React from 'react'
import styled from '~/app/components/styled'
import { Renderable } from './index'
import { Typography } from '@yanolja-org/ya-com-core'

/**
 * TitleDescriptionSmall component
 * author: soojin.oh
 */

// type definitions
export type TitleDescriptionSmallProps = {
  title: Renderable
  description: Renderable
}

// styled components
const Container = styled.div`
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 0.7rem 2rem 0.6rem;
  ${Typography('body1').regular};
`
const Title = styled.div`
  color: ${({ theme }) => theme.color.gray600};
`
const Description = styled.div`
  color: ${({ theme }) => theme.color.gray900};
`

// TitleDescriptionSmall component
const TitleDescriptionSmall: React.FunctionComponent<TitleDescriptionSmallProps> = function ({
  title,
  description,
}) {
  return (
    <Container>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Container>
  )
}

export default TitleDescriptionSmall
